import React from 'react'
import { cn } from '@/lib/utils'
import { chipVariants, type ChipVariants } from './variants'

export interface ChipProps
  extends React.HTMLAttributes<HTMLDivElement>,
    ChipVariants {
  selected?: boolean
  onClick?: () => void
}

const Chip = React.forwardRef<HTMLDivElement, ChipProps>(
  ({ className, variant, size, selected, onClick, ...props }, ref) => {
    const effectiveVariant = selected ? 'selected' : variant
    
    return (
      <div
        ref={ref}
        className={cn(
          chipVariants({ variant: effectiveVariant, size, className }),
          onClick && 'cursor-pointer'
        )}
        onClick={onClick}
        {...props}
      />
    )
  }
)
Chip.displayName = 'Chip'

export { Chip }
